import React, { FC } from 'react';
import { BasketOptionalFeesDetailsProps } from '@components/v2/BasketOptionalPartsDetails/index';
import BasketOptionalFeesTemplate from './BasketOptionalFeesTemplate';
import BasketOptionalAccessoriesTemplate from './BasketOptionalAccessoriesTemplate';

const BasketOptionalPartsTemplate: FC<BasketOptionalFeesDetailsProps> = (props) => {
    return props.showFees ? (
        <BasketOptionalFeesTemplate {...props} />
    ) : (
        <BasketOptionalAccessoriesTemplate {...props} />
    );
};

export default BasketOptionalPartsTemplate;
